<template lang="html">
  <section class="value-proposition">

    <section-intro
      heading="a unique value proposition"
      body="Your specialty is your product, our specialty is highlighting your product in an extraordinary way. We handle every aspect of your Experiential Marketing Plan to ensure a streamlined and simple process for you and your sales team."
    ></section-intro>

    <div class="vp__desktop">
      <section id="pinned" class="product-presentation">
        <div class="pp__bg pp__bg--1"></div>
        <div class="pp__bg pp__bg--2"></div>
        <div class="presentation__desc">
          <div>
            <h3 class="pd__heading">You know your product and you have a goal in mind.</h3>
            <p class="pd__p-1">We help determine the best way to display that product. We then help determine the ideal schedule for the tour. Our EMS system makes planning and tracking events (across your entire sales team) simple. And finally on the day of the event your team shows up to a ready-to-go display.</p>
            <p class="pd__p-2">Our goal is to make the entire process from concept to event feel too easy, letting you and your team focus on sales, outreach, training or whatever the goal is for that day.</p>
          </div>
        </div>
      </section>
    </div>

    <div class="vp__mobile">
     <section class="product-presentation--mobile">
       <div>
         <img src="/static/images/vp__before.jpg" alt="">
         <h3>You know your product and you have a goal in mind.</h3>
         <p>We help determine the best way to display that product. We then help determine the ideal schedule for the tour. Our EMS system makes planning and tracking events (across your entire sales team) simple. And finally on the day of the event your team shows up to a ready-to-go display.</p>
         <p>Our goal is to make the entire process from concept to event feel too easy, letting you and your team focus on sales, outreach, training or whatever the goal is for that day.</p>
       </div>
       <div>
         <img src="/static/images/vp__after.jpg" alt="">
         <h3>We believe our greatest asset is leaving our clients with the feeling that the entire process was simple and efficient.</h3>
         <p>The results of the mobile tour are self-evident from the very first event. The turn-key service we provide is second to none. All of our clients have repeat tours, or tour extensions. After measuring the success of the first year of a tour, all of our clients embark on consecutive experiential marketing tours.</p>
         <p>A great many of our tours become permanent sales tools for our clients, and our best sales tool is when our potential clients see a current client's mobile tour and just know that they want that tool for their team.</p>
       </div>
     </section>
    </div>


  </section>
</template>

<script>
  // eslint-disable-next-line no-unused-vars
  import { TweenMax, TimelineMax, CSSPlugin, Power1 } from 'gsap'
  // eslint-disable-next-line no-unused-vars
  import TextPlugin from 'gsap/TextPlugin'

  import SectionIntro from '@/components/SectionIntro'

  export default {
    components: {
      'section-intro': SectionIntro
    },
    name: 'value-proposition',
    mounted () {
      this.$nextTick(this.pinnedSection)
    },
    data () {
      return {
      }
    },
    methods: {
      pinnedSection () {
        const tl = new TimelineMax()

        tl.to('.pd__heading', 0.5, { autoAlpha: 0, ease: Power1.easeNone }, 1.5)
          .to('.pd__p-1', 0.5, { autoAlpha: 0, ease: Power1.easeNone }, 1.5)
          .to('.pd__p-2', 0.5, { autoAlpha: 0, ease: Power1.easeNone }, 1.5)
          .set('.pd__heading', { text: 'We believe our greatest asset is leaving our clients with the feeling that the entire process was simple and efficient.' })
          .set('.pd__p-1', { text: 'The results of the mobile tour are self-evident from the very first event. The turn-key service we provide is second to none. All of our clients have repeat tours, or tour extensions. After measuring the success of the first year of a tour, all of our clients embark on consecutive experiential marketing tours.' })
          .set('.pd__p-2', { text: 'A great many of our tours become permanent sales tools for our clients, and our best sales tool is when our potential clients see a current client\'s mobile tour and just know that they want that tool for their team.' })
          .to('.pp__bg--1', 1, { autoAlpha: 0, ease: Power1.easeNone })
          .fromTo('.pd__heading', 0.7, { y: '+=20' }, { y: 0, autoAlpha: 1, ease: Power1.easeOut }, '-=0.4')
          .fromTo('.pd__p-1', 0.6, { y: '+=20' }, { y: 0, autoAlpha: 1, ease: Power1.easeOut }, '-=0.6')
          .fromTo('.pd__p-2', 0.6, { y: '+=20' }, { y: 0, autoAlpha: 1, ease: Power1.easeOut }, '-=0.6')
          .set('.pd__heading', { autoAlpha: 1 }, '+=2')

        const scene = new this.$scrollmagic.Scene({
          triggerElement: '#pinned',
          duration: '200%',
          triggerHook: 'onLeave',
          reverse: true
        }).setPin('#pinned', { pushfollowers: true })
          .setTween(tl)

        this.$ksvuescr.$emit('addScene', 'pinnedSection', scene)
      },
      destroyed () {
        // Destroy ScrollMagic when our component is removed from DOM
        this.$ksvuescr.$emit('destroy')
      }
    }
  }
</script>

<style lang='scss'>
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .product-presentation {
    display: none;
    @include breakpoint($md) {
      display: block;
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 100vh;
      padding: 0;
    }
  }

  .pp__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .pp__bg--1 {
    background-image: url('/static/images/vp__before.jpg');
    z-index: 10;
  }

  .pp__bg--2 {
    background-image: url('/static/images/vp__after.jpg');
    z-index: 5;
  }

  .presentation__desc {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 1rem;
    background-color: rgba($white, 0.9);
    z-index: 20;
    h3 {
      margin: 0;
      font-family: $barlowCondensed;
      color: $dark-blue;
    }
    @include breakpoint($md) {
      width: 50%;
      height: 70%;
      padding: 0 9vw;
    }
  }

  .product-presentation--mobile {
    display: block;
    padding: 0 1rem 5rem 1rem;
    > div + div {
      margin-top: 3rem;
    }
    > div {
      h3 {
        margin-top: 1.5rem;
        font-family: $barlowCondensed;
        color: $dark-blue;
      }
      img {
        vertical-align: middle;
        width: 100%;
        height: auto;
      }
    }
    @include breakpoint($md) {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ValueProposition.vue